<template>
    <div>
      <span v-if="chartDev.type != 'CallbellMonthly'">
        <button @click="fetchChart" class="badge badge-success">{{$t('common.getData')}}</button>
        <span v-if="chartDev.type == 'Dishwasher100Cycles' && dishwasher100Cycles.pages.length">
          <select v-model="dishwasher100Cycles.page" @change="chartDishwasher100CyclesPage">
            <option v-for="(option, index) in dishwasher100Cycles.pages" :value="index" :key="index">
              {{ (option[0] + 1) }} - {{ (option[1] + 1) }}
            </option>
          </select>
          <button @click="turnDishwasher100CyclesPage(1)" class="badge badge-warning">&lt;&lt;</button>
          <button @click="turnDishwasher100CyclesPage(-1)" class="badge badge-warning">&gt;&gt;</button>
        </span>
        <span v-if="chartDev.type != 'Dishwasher100Cycles'">
          <datepicker 
            :value="vjsdpDate" 
            :format="vjsdpFormat" 
            monday-first
            wrapper-class="vjsdp-wrap"
            input-class="vjsdp-input"
            v-on:selected="setVjsdpDate">
          </datepicker>
          <img src="/static/img/calendar.svg" style="height:25px;"/>
          <select v-model="hours.h0" @change="correctHourRange">
            <option v-for="option in hours.options" :value="option.value" :key="option.value">
              {{ option.text }}
            </option>
          </select> - 
          <select v-model="hours.h1" @change="correctHourRange">
            <option v-for="option in hours.options" :value="option.value" :key="option.value">
              {{ option.text }}
            </option>
          </select>
        </span>
        <strong>{{chartDev.name}}</strong>
        <button @click="closeChart" class="badge badge-danger btn-ur">{{$t('common.close')}}</button>
      </span>
      <line-chart v-if="chartData" :chart-data="chartData" :options="chartOptions"></line-chart>
      <div v-if="chartError" class="alert alert-danger upper-space">{{chartError}}</div>
    </div>
</template>

<script>

import db from '@/firebase/init'
import LineChart from '@/components/VueChartJs'
import Datepicker from 'vuejs-datepicker'

import Callbell from '@/components/Charts/Callbell'
import Dishwasher from '@/components/Charts/Dishwasher'
import Fridge from '@/components/Charts/Fridge'

export default {
  name: 'Charts',
  mixins: [Callbell, Dishwasher, Fridge],
  components: { LineChart, Datepicker },
  props: ['chartDev'],
  data () {
    return {
      chartData: null,
      chartOptions: null,
      chartError: null,
      vjsdpDate: new Date(),
      hours: {
        h0: 0,
        h1: 24,
        options: []
      },
      
      defaultChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
              type: 'time',
              time: {                                                                                                                                                               
                  tooltipFormat: 'YYYY-MM-DD HH:mm:ss',
                  //minUnit: 'day',
                  displayFormats: {
                      millisecond: 'HH:mm:ss',
                      second: 'HH:mm:ss',
                      minute: 'HH:mm',
                      hour: 'HH:mm',
                      day: 'YYYY-MM-DD'
                  }
              }
          }],
          yAxes: [{
            type: 'linear',
            display: true,
            position: 'left',
            id: 'y-axis-1',
            scaleLabel: {
              display: true,
              labelString: '°C'
            }
          }]
        }
      }
    }
  },

  methods: {
    
    correctHourRange() {
      if(this.hours.h0 == this.hours.h1) {
        if(this.hours.h1 == 24) {
          this.hours.h0 = 23
        } else {
          this.hours.h1 = this.hours.h0 + 1
        }
      } else if(this.hours.h0 > this.hours.h1) {
        var swap = this.hours.h1
        this.hours.h1 = this.hours.h0
        this.hours.h0 = swap
      }
    },

    vjsdpFormat(date) { return date.toISOString().substr(0,10) },
    setVjsdpDate(date) { this.vjsdpDate = new Date(date.getTime()) },

    initChart() {
      this.chartData = null
      this.chartOptions = null
      this.chartError = null
      this.vjsdpDate = new Date()
      this.hours.h0 = this.vjsdpDate.getHours() - 1
      if(this.hours.h0 < 0) { this.hours.h0 = 0 }
      this.hours.h1 = 24
      this.fetchChart()
    },

    closeChart() {
      this.chartData = null
      this.chartError = null
      this.$emit('close')
    },

    fetchChart() {
      switch(this.chartDev.type) {
        case 'DishwasherHourly': return this.chartDishwasherHourly()
        case 'Dishwasher100Cycles': return this.chartDishwasher100Cycles()
        case 'Fridge': return this.chartFridge()
        case 'CallbellMonthly': return this.chartCallbellMonthly()
      }
    },

    setChartError(msg) {
      this.chartData = null
      this.chartError = msg
    },

    getChartLineData(x) {
      var chartLine = (x.type == 'event')
      ? {
        yAxisID: 'y-axis-1',
        pointRadius: 7,
        fill: false,
        lineTension: 0,
        spanGaps: false,
        showLine: false
      }
      : {
        yAxisID: 'y-axis-1',
        pointRadius: x.spec.data.length == 1 ? 10 : 0,
        fill: false,
        lineTension: 0,
        spanGaps: true,
      }
      for(var i in x.spec) { chartLine[i] = x.spec[i] }
      if('color' in x) {
        chartLine.borderColor = x.color
        chartLine.pointBackgroundColor = x.color
      }
      return chartLine
    },

    getFlatDate(date) {
      var iso = date.toISOString()
      return iso.substr(0,4) + iso.substr(5,2) + iso.substr(8,2)
    },

    handleChartPoints(data, events, min) {
      var points = 0
      for(var i in events) {
        points += events[i].length
        for(var j in events[i]) {
          if(events[i][j] !== null) {
            if(typeof events[i][j] === 'object') {
              events[i][j].y = min
            } else {
              events[i][j] = min
            }
          }
        }
      }
      for(var i in data) { points += data[i].length }
      return points ? false : this.$t('charts.err.emptySet')
    }

  },

  created() {
    for(var i = 0; i < 25; i++) {
      this.hours.options.push({text: (i < 10 ? '0' : '') + i + ':00', value: i});
    }
  },

  mounted() {
    this.initChart()
  }

}
</script>

<style>

.vjsdp-wrap {
  display: inline-block; 
}

.vjsdp-input {
  width: 10ch;
  height: 21px;
}

.btn-ur {
  float: right;
  margin-left: 5px;
}

.upper-space {
  margin-top: 10px
}

</style>



// WEBPACK FOOTER //
// src/components/Charts.vue